import { AbnyLogo } from './AbnyLogo';

interface PoweredByBadgeProps {
  position?: 'bottom-right' | 'bottom-left' | 'bottom-center' | 'center-inline' | 'inline' | 'sidebar-dock';
  className?: string;
}

export function PoweredByBadge({ position = 'bottom-right', className = '' }: PoweredByBadgeProps) {
  return (
    <a
      href="https://abny.in"
      target="_blank"
      rel="noopener noreferrer"
      className={`floating-powered-by ${position} ${className}`}
      title="Engineered & Powered by ABNY Web"
      aria-label="App is Powered By ABNY Web"
    >
      <div className="powered-by-logo-wrap">
        <AbnyLogo size={20} className="powered-by-logo" />
      </div>
      <span className="powered-by-prefix">Powered by</span>
      <span className="powered-by-brand">ABNY Web</span>
      <div className="powered-by-pulse-dot" />
    </a>
  );
}
